export const isProdBuild = process.env.NODE_ENV === 'production';
export const isProdEnv = process.env.ENV === 'production';
